import { render, staticRenderFns } from "./ChildInformation.vue?vue&type=template&id=7744944a"
import script from "./ChildInformation.vue?vue&type=script&lang=js"
export * from "./ChildInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports